import { TextField, InputAdornment, IconButton, Box } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ClearIcon from '@mui/icons-material/Clear';

export default function SearchBar({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (

    
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 3, mb: 3, display: 'flex', alignItems: 'center' }}>
  <SearchOutlinedIcon sx={{ mr: 1.5, color: 'action.active' }} />
  <TextField
    fullWidth
    size="small"
    label="Search anime…"
    variant="outlined"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    slotProps={{
      input: {
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton onClick={() => onChange('')} size="small">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      },
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: 5,
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&.Mui-focused': {
          transform: 'scale(1.03)',
          boxShadow: (t) => t.shadows[6],
        },
      },
    }}
  />
</Box>
  );
}